module.exports = __webpack_public_path__ + "img/video.796e961e.png";